import Tabla from "./tabla";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { withNotificationContext } from "js/notification-context";

const enhance = compose(
  withRouter,
  withNotificationContext,
  withApollo
);

export default enhance(Tabla);
